export const telephone1 = "1154615971";
export const telephone2 = "1157674230";

export const Contact = {
  whatsApp: `https://api.whatsapp.com/send?phone=549${telephone1}&text=Hola!,%20quisiera%20tener%20mas%20info%20sobre%20sus%20servicios!`,
  whatsApp2: `https://api.whatsapp.com/send?phone=549${telephone2}&text=Hola!,%20quisiera%20tener%20mas%20info%20sobre%20sus%20servicios!`,
  facebook: "https://www.facebook.com/VidriosLimpiosOficial/",
  mail: "info@vidrioslimpios.com.ar",
};
